
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_5700_260)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.6395 14.5295L19.4114 5.6036L18.0886 4.89639L13.3524 13.7554C13.0822 13.6755 12.7961 13.6326 12.5 13.6326C10.8431 13.6326 9.5 14.9757 9.5 16.6326C9.5 16.8069 9.51486 16.9777 9.54339 17.1438L5.36317 19.1517C4.81402 18.4506 3.95963 18 3 18C1.34314 18 0 19.3431 0 21C0 22.6569 1.34315 24 3 24C4.65685 24 6 22.6569 6 21C6 20.8393 5.98736 20.6815 5.96302 20.5276L10.161 18.5113C10.7108 19.195 11.5543 19.6326 12.5 19.6326C14.1569 19.6326 15.5 18.2894 15.5 16.6326C15.5 15.8134 15.1717 15.0709 14.6395 14.5295ZM14 16.6326C14 17.461 13.3284 18.1326 12.5 18.1326C11.6716 18.1326 11 17.461 11 16.6326C11 15.8041 11.6716 15.1326 12.5 15.1326C13.3284 15.1326 14 15.8041 14 16.6326ZM4.5 21C4.5 21.8284 3.82843 22.5 3 22.5C2.17157 22.5 1.5 21.8284 1.5 21C1.5 20.1716 2.17157 19.5 3 19.5C3.82843 19.5 4.5 20.1716 4.5 21Z","fill":"#16171F"}}),_c('ellipse',{attrs:{"cx":"18.75","cy":"5.25","rx":"5.25","ry":"5.25","fill":"#5D5CFD"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_5700_260"}},[_c('rect',{attrs:{"width":"24","height":"24","fill":"white"}})])])])
          )
        }
      }
    